import { render, staticRenderFns } from "./ITSBCGYS.vue?vue&type=template&id=27f0c031&scoped=true"
import script from "./ITSBCGYS.vue?vue&type=script&lang=js"
export * from "./ITSBCGYS.vue?vue&type=script&lang=js"
import style0 from "./ITSBCGYS.vue?vue&type=style&index=0&id=27f0c031&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f0c031",
  null
  
)

export default component.exports